import React from "react";

const CopyIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16675 1.66667C2.78604 1.66667 1.66675 2.78596 1.66675 4.16667V11.6667C1.66675 13.0474 2.78604 14.1667 4.16675 14.1667H11.6667C13.0475 14.1667 14.1667 13.0474 14.1667 11.6667V4.16667C14.1667 2.78596 13.0475 1.66667 11.6667 1.66667H4.16675ZM3.33341 4.16667C3.33341 3.70643 3.70651 3.33333 4.16675 3.33333H11.6667C12.127 3.33333 12.5001 3.70643 12.5001 4.16667V11.6667C12.5001 12.1269 12.127 12.5 11.6667 12.5H4.16675C3.70651 12.5 3.33341 12.1269 3.33341 11.6667V4.16667Z"
        fill="#070B12"
      />
      <path
        d="M15.6251 5.83333C15.1648 5.83333 14.7917 6.20643 14.7917 6.66667C14.7917 7.12691 15.1648 7.5 15.6251 7.5H15.8334C16.2937 7.5 16.6667 7.8731 16.6667 8.33333V15.8333C16.6667 16.2936 16.2937 16.6667 15.8334 16.6667H8.33342C7.87318 16.6667 7.50008 16.2936 7.50008 15.8333V15.625C7.50008 15.1648 7.12699 14.7917 6.66675 14.7917C6.20651 14.7917 5.83342 15.1648 5.83342 15.625V15.8333C5.83342 17.214 6.9527 18.3333 8.33342 18.3333H15.8334C17.2141 18.3333 18.3334 17.214 18.3334 15.8333V8.33333C18.3334 6.95262 17.2141 5.83333 15.8334 5.83333H15.6251Z"
        fill="#070B12"
      />
    </svg>
  );
};

export default CopyIcon;
